module.exports = __webpack_public_path__ + "static/media/about-new.93a90e72.png";